import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    pageHeading: {
        fontSize: '16px',
        lineHeight: '24px',
        color: '#212121',
        fontWeight: 500
    },
    displayFlex: {
        display: 'flex'
    },
    displayFlexColumn: {
        display: 'flex',
        flexDirection: 'column'
    },
    flexHorizontalCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    flexverticalCenter: {
        display: 'flex',
        alignItems: 'center'
    },
    fullyCenter: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    justifySpaceBetween: {
        justifyContent: 'space-between'
    },
    fullWidth: {
        width: '100%'
    },
    cardBackground: {
        backgroundColor: '#E3F2FD'
    },
    announcementCardHeadingText: {
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px',
        color: '#212121'
    },
    cardHeaderHeight: {
        height: '36px'
    },
    marginTop16px: {
        marginTop: theme.spacing(2)
    },
    packageDetailCardTitle: {
        backgroundColor: theme.palette.primary.light,
        padding: 8,
        borderBottom: '1px solid rgba(117, 117, 117, 0.16)'
    },
    normalText: {
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '20px',
        color: '#212121'
    },
    smallLink: {
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '20px'
    },
    headingColor: {
        color: '#616161'
    },
    justifyEnd: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    },
    primaryBackground: {
        backgroundColor: `${theme.palette.primary.light} !important`
    },
    documentTitle: {
        color: 'black'
    },
    smallText: {
        fontSize: '12px',
        color: '#616161'
    },
    tableCell: {
        width: '200px'
    },
    smallLinkFont14: {
        fontWeight: 500,
        fontSize: '14px',
        lineHeight: '20px'
    }
}));

export default useStyles;
